<template>

<div class="status">

    <div class="status-item">

        <b>{{ page.business_status_type }}</b><br/>
        {{ session.business.plan }}

    </div>

    <div class="status-item">

        <b>{{ page.business_status_start }}</b><br/>
        {{ session.business.date.started | formatDate('Do MMMM YYYY') }}

    </div>

    <div class="status-item is-buttons">

        <app-button target="_blank" href="https://billing.stripe.com/p/login/test_14kg0W2uI58z8gg7ss" :text="page.business_status_upgrade" />

    </div>

</div>
    
</template>

<script>

export default {

}

</script>

<style scoped>

.status {
    display: flex;
    flex-direction: row;
    margin-top: 40px;
    padding: 0px 5px;
}

.is-mobile .status {
    flex-direction: column;
    align-items: center;
}

.status-item {
    flex-grow: 1;
    flex-shrink: 0;
    font-size: 14px;
    line-height: 20px;
    padding-right: 20px;
    flex-basis: 0;
    white-space: nowrap;
}

.is-mobile .status-item {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}

.status-item.is-buttons {
    flex-grow: 0;
    display: flex;
    justify-content: flex-end;
    padding-right: 0px;
}

.is-mobile .status-item.is-buttons {
    justify-content: center;
    padding-left: 0px;
}

</style>